import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import Reveal from "../utils/Reveal";

const KANJI = {
  Majice: "改",
  "Muscle Fit": "筋",
  Stringeri: "善",
  Šorcevi: "力",
  Čarape: "歩",
  "Slim Fit": "静",
};

const CategoryRows = ({ categories = [] }) => {
  const navigate = useNavigate();

  const go = (name) => {
    navigate("/prodavnica", { state: { kategorija: name } });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  };

  if (!categories.length) return null;

  return (
    <Section>
      <Head>
        <Reveal>
          <SLabel>002 / Kategorije</SLabel>
          <H2>
            Nađi svoj <i>fit</i>
          </H2>
        </Reveal>
      </Head>

      <RowList>
        {categories.map((cat, i) => (
          <Reveal key={cat.id ?? cat.name} delay={i * 0.06} y={24}>
            <Row onClick={() => go(cat.name)}>
              <h3>{cat.name}</h3>
              <Meta>
                <span className="kj">{KANJI[cat.name] || "改善"}</span>
                <span className="arr">→</span>
              </Meta>
            </Row>
          </Reveal>
        ))}
      </RowList>
    </Section>
  );
};

export default CategoryRows;

const Section = styled.section`
  width: 100%;
  background: var(--bg1, #101013);
  padding: 7rem 0 0;
`;

const Head = styled.div`
  max-width: 132rem;
  margin: 0 auto;
  padding: 0 clamp(1.6rem, 4vw, 4.8rem) 4rem;
`;

const SLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  font-size: 1.1rem;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: var(--red, #fe5f55);
  font-family: "Poppins-Medium";
  margin-bottom: 1rem;

  &::before {
    content: "";
    width: 3.4rem;
    height: 1px;
    background: var(--red, #fe5f55);
  }
`;

const H2 = styled.h2`
  font-family: "Anton", sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  font-size: clamp(2.6rem, 4.6vw, 4rem);
  line-height: 1;
  letter-spacing: 0.01em;
  color: var(--text, #f4f2ee);

  i {
    font-style: normal;
    color: var(--red, #fe5f55);
  }
`;

const RowList = styled.div`
  border-bottom: 1px solid var(--line, rgba(255, 255, 255, 0.07));
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem clamp(1.6rem, 4vw, 4.8rem);
  border-top: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: var(--red, #fe5f55);
    transform: scaleY(0);
    transform-origin: bottom;
    transition: transform 0.4s var(--ease, ease);
    z-index: 0;
  }

  &:hover::before {
    transform: scaleY(1);
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  h3 {
    font-family: "Anton", sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    font-size: clamp(2.4rem, 4.4vw, 4rem);
    line-height: 1;
    letter-spacing: 0.01em;
    color: var(--text, #f4f2ee);
    transition: color 0.35s;
  }

  &:hover h3 {
    color: var(--bg0, #0a0a0c);
  }
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: 2.2rem;
  color: var(--muted, #8e8c94);
  transition: color 0.35s;

  .kj {
    font-family: var(--font-kanji);
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    color: var(--red, #fe5f55);
    opacity: 0;
    transform: translateX(-1.6rem);
    transition: all 0.4s var(--ease, ease);
  }

  .arr {
    font-size: 2.2rem;
  }

  ${Row}:hover & {
    color: var(--bg0, #0a0a0c);

    .kj {
      opacity: 1;
      transform: none;
      color: var(--bg0, #0a0a0c);
    }
  }
`;
